import { fromBinary } from '@bufbuild/protobuf';
import { MarketTradeSchema } from '@morfi/proto';
import type { ChartQueryArgs } from './live-bucket-core.js';

/**
 * Partition BC chart ordering by the outcome whose pool state changed.
 * AMM subjects are already scoped by outcome mint.
 */
export function marketChartSequenceGateSubject(
  _args: ChartQueryArgs,
  subjectPattern: string,
  event: unknown,
): string {
  if (!isMarketTradeSubject(subjectPattern)) return subjectPattern;
  if (!(event instanceof Uint8Array)) return subjectPattern;
  try {
    const outcomeIndex = fromBinary(MarketTradeSchema, event).outcomeIdx;
    return `${subjectPattern}#outcome=${outcomeIndex}`;
  } catch {
    return subjectPattern;
  }
}

function isMarketTradeSubject(subjectPattern: string): boolean {
  const tokens = subjectPattern.split('.');
  return (
    tokens[0] === 'morfi' &&
    tokens[1] === 'market' &&
    tokens.includes('user') &&
    tokens.includes('trade')
  );
}
